<template>
  <section class="residency__student-list">
     <v-container>
      <body-text>
        <v-heading level="h3">Alunos</v-heading>
        <div class="years">
          <div class="year" v-for="(year, yindex) in years" :key="yindex">
            <v-heading level="h5">{{year.title}}</v-heading>
            <ul>
              <li v-for="(student, sindex) in year.students" :key="sindex" >
                <div>
                  {{student.name}}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <v-heading level="h3">Ex Alunos</v-heading>
        <ul>
          <li v-for="(student, sindex) in currExstudentsList" :key="sindex">
            <div>
              {{student.name}}
              <span v-if="student.cbr_approved === '1'" class="badge">Titulado no CBR</span>
            </div>
          </li>
          <v-btn ref="exStudentsBtn"
            model="color-c"
            :outline="true"
            class="see-more"
            v-if="exstudents.length > 10"
            @click="showAllExStudents($event)">
              Ver mais antigos
          </v-btn>
        </ul>
      </body-text>
    </v-container>
  </section>
</template>

<script>
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Btn from '@/components/uikit/Btn.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';

export default {
  name: 'Residency',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'body-text': BodyText,
    'v-btn': Btn,
  },
  props: {
    years: {
      type: Array,
      default: () => [],
    },
    exstudents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    exstudentsFiltered() {
      return this.exstudents.slice(0, 10) || [];
    },
  },
  data() {
    return {
      currExstudentsList: [],
    };
  },
  methods: {
    showAllExStudents(event) {
      this.currExstudentsList = this.exstudents;
      this.$refs.exStudentsBtn.$el.style.display = 'none';
    },
  },
  mounted() {
    this.currExstudentsList = this.exstudentsFiltered;
  },
};
</script>

<style lang="scss" scoped>
$component: '.residency__student-list';
#{$component} {
  padding: $section-gutter 0;
  .body-text {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0 $gutter-xl;
    @media screen and (max-width: #{$brakepoint-medium}) {
      display: block;
    }
    .see-more {
      margin-top: $gutter-l;
    }
    ul li {
      margin-bottom: $gutter;
      font-size: $font-size-l;
      ul, li {
        margin-bottom: 0;
      }
      a, li:before {
        font-size: $font-size;
        color: $color-sys-f;
        text-decoration-color: $color-sys-e;
        font-weight: 300;
      }
    }
  }
  h3.heading, {
    grid-row: 1;
    margin-bottom: $gutter-xl;
    color: $color-d;
  }
  h5.heading, {
    color: $color-sys-e;
    font-size: $font-size-xl;
  }
  .badge{
    display: block;
    font-weight: 700;
    font-size: $font-size-s;
    color: $color-a;
    position: relative;
    padding-left: $gutter*2;
    &:before{
      content: '';
      width: 5px;
      height: 5px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background-color: $color-a;
      display: inline-block;
      margin-right: $gutter;
      border-radius: 100%;
      box-shadow: solid 1px white inset;
    }
  }
}
</style>
